angular.module('impactx.scheduler').controller('SchedulerFrequencyCtrl', [
    '$scope',
    'TranslationService',
    SchedulerFrequencyCtrl]);

function SchedulerFrequencyCtrl($scope, TranslationService)
{
    this.changeCheckedDate = function (date) {
        if (!$scope.frequency.readOnly) {
            date.value = !date.value
            this.checkDays();
        }
    };

    this.checkDays = function () {
        if ($scope.schedulerWarningMessage && $scope.frequency.frequencyType.selected.id == 2) {
            var result = false;
            angular.forEach($scope.frequency.frequencyType.selected.frequencies, function (frequency) {
                if (!result) {
                    if (frequency.value && (frequency.label == "29" || frequency.label == "30" || frequency.label == "31")) {
                        result = true;
                    }
                }
            });

            $scope.showSchedulerWarningMessage = result;
        }
    };

    this.checkDays();

    $scope.trns = {required: TranslationService.get("required")};
}